export const salesByChannelReportColumns = {
  date: {
    label: 'Date',
    canBeSorted: true,
    isDefault: true,
  },
  retailerId: {
    label: 'Sales channel',
    canBeHidden: true,
    isDefault: true,
  },
  country: {
    label: 'Country',
    canBeHidden: true,
    isDefault: true,
  },
  ordersCount: {
    label: 'No. of orders',
    canBeHidden: true,
    canBeSorted: true,
    isDefault: true,
  },
  unitsCount: {
    label: 'Ordered units',
    canBeHidden: true,
    canBeSorted: true,
    isDefault: true,
  },
  gmv: {
    label: 'Sales',
    canBeHidden: true,
    canBeSorted: true,
    isCurrency: true,
    isDefault: true,
  },
  aov: {
    label: 'AOV',
    canBeHidden: true,
    isCurrency: true,
    isDefault: true,
  },
  returnedUnitsCount: {
    label: 'Returned units',
    canBeHidden: true,
    canBeSorted: true,
    isDefault: true,
  },
  returnedValue: {
    label: 'Refunds',
    canBeHidden: true,
    canBeSorted: true,
    isCurrency: true,
    isDefault: true,
  },
  returnRate: {
    label: 'Return rate',
    canBeHidden: true,
    isRatePercentage: true,
    isDefault: true,
  },
  cancelledUnitsCount: {
    label: 'Cancelled units',
    canBeHidden: true,
    canBeSorted: true,
    isDefault: true,
  },
  cancellationsValue: {
    label: 'Cancellation value',
    canBeHidden: true,
    canBeSorted: true,
    isCurrency: true,
    isDefault: true,
  },
  cancellationRate: {
    label: 'Cancellation rate',
    canBeHidden: true,
    isRatePercentage: true,
    isDefault: true,
  },
  netSales: {
    label: 'Net sales',
    canBeHidden: true,
    isCurrency: true,
    isDefault: true,
  },
  currency: {
    label: 'Currency',
    hidden: true,
  },
  orderType: {
    label: 'Order type',
    canBeHidden: true,
  },
};
